import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  relevanceScore: number | null | undefined;
  children: React.ReactNode;
};

/**
 * Wraps a component with a border based on the relevance score.
 * If the relevance score is not 0 or null, the component is returned with a border
 * Otherwise, the component is returned as is.
 * The border color is determined by the relevance score.
 */
const RelevanceScoreWrapper: React.FC<Props> = ({
  relevanceScore,
  children,
}) => {
  if (!relevanceScore || relevanceScore === 0) {
    return children;
  }

  return <Container $relevanceScore={relevanceScore}>{children}</Container>;
};

const Container = styled.div<{ $relevanceScore: number }>`
  ${({ theme, $relevanceScore }) => {
    const scoreColor = getRelevanceScoreColor($relevanceScore, theme);
    return css`
      margin: ${theme.space('xxs')} 0;
      border-radius: ${theme.getTokens().border.radius.base};
      border: 1.5px solid ${`${scoreColor}`};
      padding: 0 ${theme.space('xxs')};
      box-shadow: 0 0 0 0 ${scoreColor};
    `;
  }}
`;

const getRelevanceScoreColor = (relevanceScore: number, theme) => {
  const leadscoreColors = theme.getTokens().colors.leadScore;

  if (relevanceScore === 99) return leadscoreColors.eq99;
  if (relevanceScore >= 90) return leadscoreColors.gte90;
  if (relevanceScore >= 70) return leadscoreColors.gte70;
  if (relevanceScore >= 50) return leadscoreColors.gte50;
  if (relevanceScore >= 30) return leadscoreColors.gte30;

  return leadscoreColors.lt30;
};

export default RelevanceScoreWrapper;
